import React from "react";

import {
    AccountBalance,
    AirplanemodeActive,
    AirportShuttle,
    DirectionsBoat,
    DirectionsBus,
    DirectionsCar,
    DirectionsTransit,
    DirectionsWalk,
    Flight,
    Home,
    House,
    LocalTaxi,
    ModeOfTravel,
    Train,
    Tram,
    Hail,
    EscalatorWarning,
    Public
} from "@mui/icons-material";

import {AirplaneTicket, AssignmentInd, Groups, Launch, Visibility} from "@material-ui/icons";
import {Slide, Typography, Tooltip} from "@material-ui/core";

import {zonedTimeToUtc } from "date-fns-tz";

import { cLog, cWarn, customLogger } from "../components/igtm/CustomLogger";
import axios from "../utils/axios";




export const formatAddressToString = (address) => {

    const line1Parts = [];
    if(address.houseNumber){
        line1Parts.push(address.houseNumber);
    }
    if(address.houseName){
        line1Parts.push(address.houseName);
    }
    if(address.street){
        line1Parts.push(address.street);
    }
    const line1 = line1Parts.join(' ');

    const addr = [];
    if(line1){
        addr.push(line1);
    }
    if(address.town){
        addr.push(address.town);
    }

    if(address.postcode){
        addr.push(address.postcode);
    }

    return addr.join(', ');
};

export const getTrainStationIdFromLeg = (leg) => {

    
    console.log(leg);
    try{
        const {
            mode='',
            destination:{
                type='',
                stationAddress:{
                    id:stationId='',
                    stopLocationLinks=[]
                }={},
                trainStationId=''
            }
        } = leg;

        if(type === 'trainStation'){
            return stationId;
        }
        if(trainStationId){
            return trainStationId;
        }
        
        for(let i =0; i<stopLocationLinks.length; i+=1){
            console.log(stopLocationLinks[i]);
            const {transitLocation=false} = stopLocationLinks[i];
            if(transitLocation){
                const  {id:trainStationId=''} = transitLocation;
                if(trainStationId){
                    return trainStationId;
                }
            }                    
        }
    }
    catch(e){
        console.warn(e);
    }
    return false;
}

export const formatAddressToStringShort = (address) =>  {
    const line1Parts = [];
    if(address.houseNumber){
        line1Parts.push(address.houseNumber);
    }
    if(address.houseName){
        line1Parts.push(address.houseName);
    }
    if(address.street){
        line1Parts.push(address.street);
    }
    const line1 = line1Parts.join(' ');

    const addr = [];
    if(line1){
        addr.push(line1);
    }
    if(address.town){
        addr.push(address.town);
    }



    return addr.join(', ');

}

export const simpleClone = (obj) => JSON.parse(JSON.stringify(obj));


export const stringAvatar = (name) => {
    const initials = `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`;
    return {
        children: initials,
    };
}

export const converToMiles = (meters) => {
    const miles = meters/1609;
    let output = 0;
    if(miles < 10){
        output = Math.round(miles*10)/10;
    }
    else{
        output = Math.round(miles);
    }
    return output;
}


export const iconMap = {
    'AirportShuttle':<AirportShuttle/>,
    'LocalTaxi':<LocalTaxi/>,
    'DirectionsCar':<DirectionsCar/>,
    'Train':<Train/>,
    'DirectionsWalk':<DirectionsWalk/>,
    'DirectionsBoat':<DirectionsBoat/>,
    'House':<House/>,
    'Home':<Home/>,
    'Flight':<Flight/>,
    'Flying':<AirplaneTicket/>,
    'AccountBalance':<AccountBalance/>,
    'AirplanemodeActive':<AirplanemodeActive/>,
    'DirectionsTransit':<DirectionsTransit/>,
    'DirectionsBus':<DirectionsBus/>,
    'OtherMode':<ModeOfTravel/>,
    'PublicTransport':<Tram/>,
    'Open': <Launch/>,
    'Travel':<Visibility />,
    'OwnTaxi':<Hail/>,
    'Groups':<Groups/>,
    'InPerson':<EscalatorWarning/>,
    'Public':<Public/>

};

export const outputCurrencyPence = (str) => {
    if(str > 0){
        return  (new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })).format(str);
    }
    return '';
}

export const setKeyValueToDestination = (context,key,value) => {
    context.getTravelObject().destination[key] = value;
    context.setState({});
}

/* eslint-disable */
export const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
/* eslint-enable */


export const applyStayingAtSchool = (travelObj) => {
    travelObj.destination.friendlyAddress = 'Remaining at School';
}

export const applyDefaultOtherInternationalTravelObject = (travelObj) => {
    travelObj.destination = {

    };
}

export const applyDefaultInternationalFlightObject = (travelObj) => {

    travelObj.destination = {
        flightByTimeTable:false,
        useFlightNo:true,
        flightNo:'',
        airportFrom:'',
        airportTo:''
    };
}

export const applyDefaultDomesticFlightObject = (travelObj) => {

    travelObj.transportData = {
        flightByTimeTable:false,
        useFlightNo:true,
        flightNo:'',
        airportFrom:'',
        airportTo:''
    };
    travelObj.destination = {...travelObj.destination,...{}}
}


export const getFriendlyAddress = (point) => {

    try{
        if(point.type === 'internationalFlight'){
            const {
                flightData:{
                    arrivalAirport='',
                    departureAirport='',
                    departureTerminal='',
                    arrivalTerminal='',
                    direction=''
                } = {
                    arrivalAirport:'',
                    departureAirport:'',
                    departureTerminal:'',
                    arrivalTerminal:'',
                    direction:''
                }
            } = point;
            // cLog(point);
            // cLog(name);
            if(direction === 'incoming'){
                return `${arrivalAirport}${arrivalTerminal  ? `, Terminal ${arrivalTerminal}` : ''}`;
            }
            if(direction === 'outgoing'){
                return `${departureAirport}${departureTerminal ? `, Terminal ${departureTerminal}` : ''}`;
            }
        }
        if(point.type === 'schoolLocation'){
            return point.address.name;
        }
        if(point.type === 'airport'){
            
            const {
                stationAddress:{
                    name=''
                } = {},
                departing=false,
                flightData:{
                    arrivalAirport='',
                    departureAirport='',
                    departureTerminal='',
                    arrivalTerminal=''
                } = {
                    arrivalAirport:'',
                    departureAirport:'',
                    departureTerminal:'',
                    arrivalTerminal:''
                }
            } = point;
            // cLog(point);
            // cLog(name);
            if(departing && departureAirport !== ''){
                return `${departureAirport}${departureTerminal ? `, Terminal ${departureTerminal}` : ''}`;
            }
            if(!departing && arrivalAirport !== ''){
                return `${arrivalAirport}${arrivalTerminal  ? `, Terminal ${arrivalTerminal}` : ''}`;
            }

            return name;
        }
        if(point.type === 'busStation'){
            return point.stationAddress.name;
        }
        if(point.type === 'trainStation'){
            const {stationAddress = false} = point;
            if(stationAddress){
                const {Name:stationName=''} = stationAddress;
                return stationName;
            }
        }
        if(point.type === 'otherInternationalTravel'){
            return point.additionalAddress.travel_hub_name;
        }
        if(point.type === 'schoolCoachStop'){
            return point.stationAddress.name;
        }
        if(point.friendlyAddress){
            return point.friendlyAddress;
        }
        cLog(point);
        return '';
    }
    catch(e){
        cWarn(e);
        return '';
    }
}
export const hoursMinFromTime = (tTime) => {
    if( typeof tTime === 'string'){
        tTime = new Date(tTime);
    }

    const hoursMin = {
        hours:tTime.getHours(),
        mins:tTime.getMinutes()
    };

    return hoursMin;
}

export const hoursMinToTimeString = (hoursMin) => {

    const hours = String(hoursMin.hours).padStart(2,'0');
    const mins = String(hoursMin.mins).padStart(2,'0');
    return `${hours}:${mins}`;
}

export const formatTime = (time) => {
    try {
        return new Intl.DateTimeFormat("en-GB", {
            hour: 'numeric', minute: 'numeric'
        }).format(new Date(time));
    }
    catch(e){
        // console.warn(e);
        return '';
    }
}

export const identifyReturnTravelDate = (bookingsContext) => {
        const {
            accademicYearsRaw:acYears=[],
            bookingData:{
                holidayTag=''
            }
        } = bookingsContext;
        let holidayId = null;
        if (typeof holidayTag === 'string' && holidayTag.trim() !== '') {
            const tagParts = holidayTag.split('_');
            if (tagParts.length > 1) {
                holidayId = parseInt(tagParts[1], 10);
            }
        }
    
        if (holidayId !== null) {
            // Use holidayId as an integer for searching inside the main array
            for(let i=0; i<acYears.length; i+=1){
                const {
                    schoolHolidays = [],
                } = acYears[i];
                for(let j=0; j<schoolHolidays.length; j+=1){
                    const {
                        id:holidayIdToCheck,
                    } = schoolHolidays[j];
                    if(holidayIdToCheck === holidayId){
                        const{
                            holidayEndDates=[]
                        } = schoolHolidays[j];
                        if(holidayEndDates.length > 0){
                            // return dat
                            return holidayEndDates[0];
                        }
                    }
                    
                }
    
            }
        }
        return null;
    }

export const getFromAndTo = (bookingsContext,focusPointType='', focusIndex) => {
    

    if(focusPointType === 'travelDestination') {
        if (bookingsContext.legIndex === -1) {
            focusIndex = false;
            if (bookingsContext.bookingData.direction === 'outgoing') {
                focusPointType = 'destination';
            } else {
                focusPointType = 'origin';
            }
        }
        else{
            focusIndex = bookingsContext.legIndex;
        }
    }

    let from = {};
    let to = {};
    if(focusPointType === 'origin'){
        // underLabel = bookingsContext.getDestinationPointPlaceholders(bookingsContext.bookingData.origin.destination).title;
    }
    if(focusPointType === 'destination'){
        // underLabel = bookingsContext.getDestinationPointPlaceholders(bookingsContext.bookingData.destination.destination).title;
    }
    if(focusPointType === 'travelDestination'){
        // underLabel = bookingsContext.getDestinationPointPlaceholders(bookingsContext.getLegById(bookingsContext.legIndex).destination).title;
    }
    if(focusPointType === 'travelMode'){
        
        if(bookingsContext.bookingData.legs.length > 0){
            if(focusIndex !== false){
                from = bookingsContext.getLegByIdWithOrigin(focusIndex-1);
                to = bookingsContext.getLegByIdWithOrigin(focusIndex);
            }
            else{
                from = bookingsContext.getLegByIdWithOrigin(bookingsContext.legIndex);
                to = bookingsContext.bookingData.destination;
            }
        }
        else{
            from = bookingsContext.bookingData.origin;
            to = bookingsContext.bookingData.destination;
        }
        
    }
    return {
        from:getShortFriendlyAddress(from.destination),
        to:getShortFriendlyAddress(to.destination)
    }

}

export const formatTimeForceTimeZone = (time) => {
    
    try {
        const date = new Date(time);       
        let hours = '';
        let mins = '';
        if(time.includes('+')){
            hours = String(date.getHours() + (date.getTimezoneOffset()/60)).padStart(2,'0');
            mins = String(date.getMinutes()).padStart(2,'0');
        }
        else{
            hours = String(date.getHours()).padStart(2,'0');
            mins = String(date.getMinutes()).padStart(2,'0');
        }
        return `${hours}:${mins}`;

    }
    catch(e){
        // console.warn(e);
        return '';
    }
}

export const formatDate = (date) => {
    if(date){
        return new Intl.DateTimeFormat("en-GB", {year: "numeric", month: "short", day: "2-digit", timeZone: "Europe/London"}).format(new Date(date));
    }
    return '';
}

export const formatDateUTC = (date) => {
    if(date){
        return new Intl.DateTimeFormat("en-GB", {hour: "numeric", minute: "numeric", timeZone: "UTC"}).format(new Date(date));
    }
    return '';
}

export const formatDateCatchTimezone = (date) => {
    if(date){
        try{
            const testDate = new Date(date);
            if(testDate.getHours() === 23){
                testDate.setDate(testDate.getDate()+1);
            }
            return new Intl.DateTimeFormat("en-GB", {year: "numeric", month: "short", day: "2-digit", timeZone: "Europe/London"}).format(testDate);
        }
        catch(e){
            // // console.log(date);
            // // console.log(e);
            return '';
        }

    }
    return '';
}



export const getShortFriendlyAddress = (point) => {
    if(point){
        try{
            if(point.type === 'home'){
                return point.address.town;
            }
            return getFriendlyAddress(point);
        }
        catch(e){
            // console.log(e);
            // console.log(point);
            return '';
        }
    }
    return '';
    
}

export const cancelBooking = (id,onSuccess) => {
    const apiPath = `${process.env.REACT_APP_API_URL}/cancelbooking`;
    axios.post(apiPath,{
        bookingId:id
    },{
        timeout: 30000,
        withCredentials:true
    }).then(res => {
        // console.log(res);
        onSuccess(res);
    }).catch(err => {
        customLogger(err);
    });
}

const formatTimeWithIntegers = (time,hoursMin) => {

    try {
        

        const {hours=false,mins=false} = hoursMin;
        if(hours !== false && mins !== false){
            const hoursString = String(hours).padStart(2,'0');
            const minsString = String(mins).padStart(2,'0');
            return `${hoursString}:${minsString}`;
        }


        const utcDate = zonedTimeToUtc(time, 'Europe/London');
        const output = new Intl.DateTimeFormat("en-GB", {
            hour: 'numeric',
            minute: 'numeric',
            timeZone: 'Europe/London'
        }).format(utcDate);
        return output;

        
        
    }
    catch(e){
        console.warn(e);
        return '';
    }
}



export const getTransportPointPlaceholders = (pointObject,textContent,modeTypesMap,direction) => {
    let title = textContent.unknownTravelMode;
    let bodyText = <> </>;
    let timeLabel = '';
    let icon = <Typography className="iconHelp" variant="h6">?</Typography>;
    let modeInfo = {};
    if(pointObject) {
        if (pointObject.mode) {
            try {
                modeInfo = modeTypesMap[pointObject.mode];
                icon = iconMap[modeInfo.icon];
                title = textContent[modeInfo.textKey];
                switch (pointObject.mode) {
                    case 'schoolCoach': {
                        const {
                            hours:departureHours='',
                            mins:departureMins=''
                        } = getComponentsFromUtcDate(pointObject.transportData.route.originStop.routeStop.time);
                        const{
                            hours:arrivalHours='',
                            mins:arrivalMins=''
                        } = getComponentsFromUtcDate(pointObject.transportData.route.destinationStop.routeStop.time);
                        bodyText = (
                            <div>
                                <strong>
                                    {pointObject.transportData.route.route.name}
                                </strong>
                                <div>
                                    Departing {pointObject.transportData.route.originStop.routeStop.StopLocation.name} at {departureHours}:{departureMins}
                                </div>
                                <div>
                                    Arriving {pointObject.transportData.route.destinationStop.routeStop.StopLocation.name} at {arrivalHours}:{arrivalMins}
                                </div>
                            </div>
                        );
                        break;
                    }
                    case 'bookMeATaxi': {
                        if(pointObject.transportData) {
                            const {
                                luggage=0,
                                selfBook=0,
                                shareTaxi=0,
                                selfBookCompanyName='',
                                selfBookCompanyPhone='',
                                selfBookDriverName='',
                                selfBookDriverMobile='',
                                travelTime,
                                description,
                                hoursMin=[]
                            } = pointObject.transportData;
                            timeLabel = formatTimeWithIntegers(travelTime,hoursMin); 
                             

                            bodyText = (
                                <>
                                    {selfBook === '1' ?
                                        <>
                                            <strong>Self-booked Taxi</strong>
                                            <div>
                                                {selfBookCompanyName}<br/>
                                                {selfBookDriverName && <>{selfBookDriverName}<br/></>}
                                                {selfBookCompanyPhone && <>T: {selfBookCompanyPhone}<br/></>}
                                                {selfBookDriverMobile && <>M: {selfBookDriverMobile}<br/></>}
                                            </div>
                                        </>
                                        :
                                        <>
                                            {shareTaxi === '1' ? <>{textContent.openToSharing}<br/></> : <>{textContent.notSharing}<br/></> }
                                            {luggage && <>{textContent.luggageLabel} {luggage}<br/></>}
                                            {description && <>{textContent.additionalNotesLabel} {description}</>}
                                        </>
                                    }


                                </>
                            );
                        }
                        break;
                    }

                    case 'privateCar': {
                        if(pointObject.transportData){
                            if('driverData' in pointObject.transportData) {
                                if(direction === 'outgoing'){
                                    if ('travelTime' in pointObject.transportData.driverData) {
                                        timeLabel = formatTime(pointObject.transportData.driverData.travelTime);
                                    }
                                    if('hoursMin' in pointObject.transportData.driverData){
                                        timeLabel = hoursMinToTimeString(pointObject.transportData.driverData.hoursMin);
                                    }
                                }
                                let driverName = 'Unknown';
                                if ('driverData' in pointObject.transportData) {
                                    if (pointObject.transportData.type === 'existing') {
                                        if ('meta' in pointObject.transportData.driverData) {
                                            driverName = pointObject.transportData.driverData.meta.label;
                                        }
                                    } else {
                                        driverName = pointObject.transportData.driverData.newDriverName;
                                    }
                                }


                                bodyText = (<>
                                    Driven By {driverName}<br/>
                                    {'vehicleData' in pointObject.transportData &&
                                    <>
                                        {'make' in pointObject.transportData.vehicleData && <span
                                            style={{textTransform: 'capitalize'}}>{pointObject.transportData.vehicleData.colour} {pointObject.transportData.vehicleData.make}, </span>} {pointObject.transportData.registration && <>Registration: <span
                                        style={{textTransform: 'uppercase'}}>{pointObject.transportData.registration}</span></>}
                                    </>
                                    }
                                </>);
                            }
                        }
                        break;
                    }
                    case 'getMeThere': {
                        
                        ({getMeThereSummaryText:bodyText} = textContent);
                        break;
                    }
                    case 'train': {

                        const {transportData} = pointObject;
                        if(transportData){
                            const {
                                route:{
                                    route:trainRoute=[],
                                    departureOrArrival='1'
                                }={}
                            } = transportData;
    
                            title = textContent[modeInfo.textKey];
                            if(trainRoute.length > 0){
                                bodyText = (
                                    <>
                                        {trainRoute.map((leg, index) =>
                                            (
                                                <div key={index}>
                                                    <div>
                                                        {leg.company}, {textContent.textDeparting} {leg.departureStop} {textContent.textAt} {leg.departureFormatted}. {textContent.textArriving} {leg.arrivalStop} {textContent.textAt} {leg.arrivalFormatted}
                                                    </div>
                                                </div>
                                            ))}
                                    </>
                                );
                            }
                            else{
                                bodyText = (
                                    <>
                                       Unknown Route 
                                    {departureOrArrival === '1' ? 
                                        <>{textContent.textDeparting} {textContent.textAt} {formatTime(pointObject.transportData.departureTime)}</>
                                    :
                                    
                                        <>{textContent.textArriving} {textContent.textAt} {formatTime(pointObject.transportData.arrivalTime)}</>
                                    }
                                    </>
                                );
                            }
                        }
                        
                        break;
                    }
                    case 'walk':

                        break;
                    case 'flying':{
                        cLog(pointObject);


                        const {
                            transportData:{
                                flightNo='',
                                flightData={}
                            }
                        } = pointObject;

                        if(Object.keys(flightData).length !== 0){

                            const {
                                airline='',
                                manuallyEntered=false,
                                departureAirportCode='',
                                departureTerminal='',
                                departureHoursMin=false,
                                arrivalAirportCode='',
                                arrivalTerminal='',
                                arrivalHoursMin=false,
                                departureTime:{
                                    date:departureTimeStamp=''
                                } = {},
                                arrivalTime:{
                                    date:arrivalTimeStamp=''
                                } = {}
                            } = flightData;

                            const {
                                departingFlightTitle,
                                arrivingFlightTitle,
                                flightLabelTerminal
                            } = textContent;

                            if(manuallyEntered){
                                bodyText = (
                                    <>
                                        <strong>{flightNo} {airline}</strong><br/>
                                        
                                        {direction === 'outgoing' ?
                                        
                                        <>
                                        <Typography variant="h5">{departingFlightTitle}</Typography>
                                        {departureAirportCode}{departureTerminal ? `, ${flightLabelTerminal} ${departureTerminal}` : ''} at {hoursMinToTimeString(departureHoursMin)}
                                        </>
                                        :
                                        <>
                                        <Typography variant="h5">{arrivingFlightTitle}</Typography>
                                        {arrivalAirportCode}{arrivalTerminal ? `, ${flightLabelTerminal} ${arrivalTerminal}` : ''} at {hoursMinToTimeString(arrivalHoursMin)}
                                        </>
                                        }
                                    </>);
                            }
                            else{

                                const startTime = new Date(departureTimeStamp);
                                startTime.setHours(startTime.getHours() - 3);
                                timeLabel = formatTime(startTime);
        
                                bodyText = (
                                    <>
                                        <strong>{flightNo} {airline}</strong><br/>
                                        <Typography variant="h5">{departingFlightTitle}</Typography>
                                        {departureAirportCode}{departureTerminal ? `, ${flightLabelTerminal} ${departureTerminal}` : ''} at {formatTimeForceTimeZone(departureTimeStamp)}
                                        <Typography variant="h5">{arrivingFlightTitle}</Typography>
                                        {arrivalAirportCode}{arrivalTerminal ? `, ${flightLabelTerminal} ${arrivalTerminal}` : ''} at {formatTimeForceTimeZone(arrivalTimeStamp)}
                                    </>
                                );
                            }
                        }


                        break;
                    }
                    case 'other':
                        timeLabel = formatTime(pointObject.transportData.travelTime);
                        bodyText = (
                            <>
                                Transport type: {pointObject.transportData.name}<br/>
                                Description: {pointObject.transportData.description}
                            </>
                        );
                        break;
                    case 'publicTransport':
                        timeLabel = formatTime(pointObject.transportData.travelTime);
                        bodyText = (
                            <>
                                Transport type: {pointObject.transportData.name}<br/>
                                Description: {pointObject.transportData.description}
                            </>
                        );
                        break;
                    default:
                        console.error('The destination or origin type has not been identified');
                }
            } catch (e) {
                cWarn(e);
                return {};
            }
        }
    }
    return {
        title,
        bodyText,
        timeLabel,
        icon
    }
}

export const getDestinationPointPlaceholders = (pointObject,textContent,destinationTypesMap,direction) => {

    let title = textContent.unknownDestination;
    let icon = <Typography className="iconHelp" variant="h6">?</Typography>;
    let bodyText = '';
    let timeLabel = '';

    if(pointObject.type) {
        const destinationTypeInfo = destinationTypesMap[pointObject.type];
        try {
            title = textContent[destinationTypeInfo.textKey];
            icon = iconMap[destinationTypeInfo.icon];
        } catch (e) {
            // console.log('Error in assigining the text key from the following object:');
            // console.log(destinationTypeInfo);
            // console.log('with point object runnign lie this:');
            // console.log(pointObject);
            // console.log(e.message);
        }

        bodyText = getFriendlyAddress(pointObject);



        switch (pointObject.type) {
            case 'home': {

                break;
            }
            case 'schoolLocation': {

                break;
            }
            case 'otherDomesticAddress':

            break;

            case 'foreignAddress':

            break;

            case 'stayingAtSchool':

            break;
            case 'internationalFlight': {


                
                if (pointObject.flightData) {
                    const {flightNo='',flightData} = pointObject;
                    let airportLabel = pointObject.flightData.departureAirport;
                    if (direction === 'incoming') {
                        airportLabel = pointObject.flightData.arrivalAirport;
                    }

                    title = airportLabel;
                    
                    
                    const {airline=''} = flightData;
                    
                    if(flightData.manuallyEntered){
                        bodyText = (
                            <>
                                <strong>{flightNo &&  flightNo} {airline && airline}</strong><br/>
                                
                                {direction === 'outgoing' ?
                                
                                <>
                                <Typography variant="h5">{textContent.departingFlightTitle}</Typography>
                                {pointObject.flightData.departureAirportCode}{pointObject.flightData.departureTerminal ? `, ${textContent.flightLabelTerminal} ${pointObject.flightData.departureTerminal}` : ''} at {hoursMinToTimeString(pointObject.flightData.departureHoursMin)}
                                </>
                                :
                                <>
                                <Typography variant="h5">{textContent.arrivingFlightTitle}</Typography>
                                {pointObject.flightData.arrivalAirportCode}{pointObject.flightData.arrivalTerminal ? `, ${textContent.flightLabelTerminal} ${pointObject.flightData.arrivalTerminal}` : ''} at {hoursMinToTimeString(pointObject.flightData.arrivalHoursMin)}
                                </>
                                }
                            </>
                        );
                    }
                    else{
                        const startTime = new Date(pointObject.flightData.departureTime.date);
                        startTime.setHours(startTime.getHours() - 3);
                        timeLabel = formatTime(startTime);

                        bodyText = (
                            <>
                                <strong>{flightNo &&  flightNo} {airline && airline}</strong><br/>
                                <Typography variant="h5">{textContent.departingFlightTitle}</Typography>
                                {pointObject.flightData.departureAirportCode}{pointObject.flightData.departureTerminal ? `, ${textContent.flightLabelTerminal} ${pointObject.flightData.departureTerminal}` : ''} at {formatTimeForceTimeZone(pointObject.flightData.departureTime.date)}
                                <Typography variant="h5">{textContent.arrivingFlightTitle}</Typography>
                                {pointObject.flightData.arrivalAirportCode}{pointObject.flightData.arrivalTerminal ? `, ${textContent.flightLabelTerminal} ${pointObject.flightData.arrivalTerminal}` : ''} at {formatTimeForceTimeZone(pointObject.flightData.arrivalTime.date)}
                            </>
                        );
                    }

                    
                }
                break;
            }
            case 'otherInternationalTravel':
                break;
            case 'airport': {

                const {
                    stationAddress:{
                        name=''
                    } = {},
                    departing=false,
                    flightData:{
                        arrivalAirport='',
                        departureAirport='',
                    } = {
                        arrivalAirport:'',
                        departureAirport:'',
                    }
                } = pointObject;

                if(departing && departureAirport !== ''){
                    title = departureAirport;
                }
                if(!departing && arrivalAirport !== ''){
                    title = arrivalAirport;
                }
    
                title = name;
                break;
            }
            case 'trainStation': {
                if (pointObject.stationAddress) {
                    title = `${pointObject.stationAddress.Name} (${pointObject.stationAddress.shortName})`;
                }
                break;
            }
            case 'inPersonDropoff': {
                if ('travelTime' in pointObject) {
                    if('hoursMin' in pointObject){
                        timeLabel = hoursMinToTimeString(pointObject.hoursMin);
                    }
                    else{
                        timeLabel = formatTime(pointObject.travelTime);
                    }
                    bodyText = `Person dropping-off: ${pointObject.driverData.label}`;
                }
                break;
            }
            case 'inPersonCollection': {
                if ('travelTime' in pointObject) {
                    if('hoursMin' in pointObject){
                        timeLabel = hoursMinToTimeString(pointObject.hoursMin);
                    }
                    else{
                        timeLabel = formatTime(pointObject.travelTime);
                    }
                    bodyText = `Person collecting: ${pointObject.driverData.label}`;
                }
                break;
            }
            case 'schoolCoachStop':
                break;
            case 'busStation':
                break;
            default:
                timeLabel = '';
        }
    }
    return {
        title,
        bodyText,
        timeLabel,
        icon
    }
}

export const StaffApprovalIcon = (props) => {

    let housemClass = 'unapproved';
    let housemTip = 'Awaiting staff approval';
    if(props.booking) {
        const housemApproval = props.booking.housemApprovedDate;
        const parentApproval = props.booking.parentApprovedDate;
        if (housemApproval) {
            housemClass = 'partApproved';
            housemTip = `Staff approved ${formatDate(housemApproval)}`;
        }
        if (housemApproval && parentApproval) {
            housemClass = 'fullyApproved';
        }
        return (
            <Tooltip title={housemTip}>
                <AssignmentInd className={housemClass} />
            </Tooltip>
        );
    }
    return '';
}

export const ParentApprovalIcon = (props) => {

    let parentTip = 'Awaiting parental approval';
    let parentClass = 'unapproved';
    if(props.booking) {
        const housemApproval = props.booking.housemApprovedDate;
        const parentApproval = props.booking.parentApprovedDate;
        if (parentApproval) {
            parentClass = 'partApproved';
            parentTip = `Parent approved ${formatDate(parentApproval)}`;
        }
        if (housemApproval && parentApproval) {
            parentClass = 'fullyApproved';
        }
        return (
            <Tooltip title={parentTip}>
                <AssignmentInd className={parentClass}/>
            </Tooltip>
        );
    }
    return '';
}

export const getComponentsFromUtcDate = (dateString) => {
    
    try{
        const dateParts = dateString.split('T');
        const dateBits = dateParts[0].split('-');
        const timeBits = dateParts[1].split(':');
        return {
            year:dateBits[0],
            month:dateBits[1],
            day:dateBits[2],
            hours:timeBits[0],
            mins:timeBits[1],
            secs:timeBits[2]
        }
    }
    catch(e){
        return {
            year:'',
            month:'',
            day:'',
            hours:'',
            mins:'',
            secs:''
        }
    }
    
    
}


export const processAccademicYearToList = (travelDatesData) =>{
    let defDate = '';
    const windowOptions = [];
    const now = new Date();
    for(let i=0; i<travelDatesData.length; i+=1){
        const accademicYear = travelDatesData[i];
        const {
             yearStart,
             yearEnd,
             id:yearId,
             accademicYearsToTravelDays:startEndTravelDates=[],
             schoolHolidays=[],
         } = accademicYear;
        
        const yearLabel = `${getComponentsFromUtcDate(yearStart).year.substr(2)}/${getComponentsFromUtcDate(yearEnd).year.substr(2)}`;
        for(let j=0; j<startEndTravelDates.length; j+=1){
             const {travelDate} = startEndTravelDates[j];
             if(travelDate !== null){
                const {directionType:{id:directionTypeId},travelDate:tDate} = travelDate;
                if(directionTypeId === 1){
                    windowOptions.push({
                        label:`${yearLabel} - Year Start`,
                        value:`acYearStart_${yearId}`,
                        date:tDate
                    });
                    break;
                }
            }
        }

        for(let j=0; j<schoolHolidays.length; j+=1){
             const{
                 name:holidayName,
                 id:holidayId,
                 schoolHolidayToTravelDates:holidayTravelDates=[],
             } = schoolHolidays[j];

             if(holidayTravelDates.length > 0){
                 const firstTravelDate = holidayTravelDates[0];
                 const {travelDate:travelDateObject} = firstTravelDate;
                 if(travelDateObject !== null){
                    const {travelDate:tDate} = travelDateObject;
                    windowOptions.push({
                        label:`${yearLabel} - ${holidayName}`,
                        value:`holiday_${holidayId}`,
                        date:tDate
                    });
                }
             }

             
        }

        for(let j=0; j<startEndTravelDates.length; j+=1){
             const {travelDate} = startEndTravelDates[j];
             if(travelDate !== null){
                const {directionType:{id:directionTypeId},travelDate:tDate} = travelDate;
                
                if(directionTypeId === 2){
                    windowOptions.push({
                        label:`${yearLabel} - Year End`,
                        value:`acYearEnd_${yearId}`,
                        date:tDate
                    });
                    break;
                }
            }
         }


     }
     

     for(let i=0; i<windowOptions.length; i+=1){
         if(!defDate){
             if(now < new Date(windowOptions[i].date)){
                 defDate = windowOptions[i].value;
             }
         }
     }     
     return {windowOptions,defDate};

}


export const getPassengerFromStb = (stb) => {
    const {
        student = null,
        contact = null,
        staff = null
    } = stb;
    const output = {};
    if(student){
        const {
            firstName='',
            lastName='',
            email='',
            metaData=null,
            lastNameInitital='',
            id
        } = student;

        let mobile = '';
        if(metaData){
            ({mobile=''} = metaData);
        }

        output.passenger = student;
        output.type = 'student';
        output.id = id;
        output.contacts = {
            firstName,
            lastName,
            lastNameInitital,
            email,
            mobile
        };
        return output;
    }
    if(contact){

        const {
            firstName='',
            lastName='',
            email='',
            mobile='',
            lastNameInitital='',
            id
        } = contact;

        output.passenger = contact;
        output.type = 'contact';
        output.id = id;
        output.contacts = {
            firstName,
            lastName,
            lastNameInitital,
            email,
            mobile
        };
        return output;
    }
    if(staff){

        const {
            firstName='',
            lastName='',
            email='',
            mobile='',
            lastNameInitital='',
            id
        } = staff;

        output.passenger = staff;
        output.type = 'staff';
        output.id = id;
        output.contacts = {
            firstName,
            lastName,
            lastNameInitital,
            email,
            mobile
        };
        return output;
    }
    return null;
}